<template>
  <div ref="picker"></div>
</template>

<script>
import iro from '@jaames/iro';

export default {
  props: {
    value: {
      type: String,
      default: '#ffffff',
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 300,
    },
    handleSvg: {
      type: String,
      default: null,
    },
    handleOrigin: {
      type: Object,
      default() {
        return {
          x: 0,
          y: 0,
        };
      },
    },
    padding: {
      type: Number,
      default: 6,
    },
    handleRadius: {
      type: Number,
      default: 8,
    },
    sliderMargin: {
      type: Number,
      default: 24,
    },
    sliderHeight: {
      type: Number,
      default: undefined,
    },
    borderWidth: {
      type: Number,
      default: 0,
    },
    borderColor: {
      type: String,
      default: '#ffffff',
    },
    display: {
      type: String,
      default: 'block',
    },
    layout: {
      type: String,
      default: 'block',
    },
    wheelAngle: {
      type: Number,
      default: 0,
    },
    wheelDirection: {
      type: String,
      default: 'anticlockwise',
    },
    wheelLightness: {
      type: Boolean,
      default: true,
    },
    css: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      color: this.value,
      colorPicker: null,
    };
  },
  mounted() {
    this.colorPicker = new iro.ColorPicker(this.$refs.picker, {
      width: this.width,
      height: this.height,
      handleSvg: this.handleSvg,
      color: this.color,
      padding: this.padding,
      display: this.display,
      css: this.css,
      wheelDirection: this.wheelDirection,
      wheelAngle: this.wheelAngle,
      wheelLightness: this.wheelLightness,
      handleOrigin: this.handleOrigin,
      handleRadius: this.handleRadius,
      sliderMargin: this.sliderMargin,
      sliderHeight: this.sliderHeight,
      borderWidth: this.borderWidth,
      borderColor: this.borderColor,
      layout: [
        {
          component: iro.ui.Wheel,
          options: {
            borderColor: '#000000',
          },
        },
      ],
    });
    this.colorPicker.on('input:end', this.onInputEnd);
    this.colorPicker.on('color:change', this.onColorChange);
  },
  methods: {
    onInputEnd(color) {
      this.$emit('input', color.hexString);
    },
    onColorChange(color) {
    },
  },
  watch: {
    value(newValue) {
      if (this.colorPicker.color) {
        this.colorPicker.color.hexString = newValue;
      }
    },
  },
  destroyed() {
    this.colorPicker.off('input:end', this.onInputEnd);
  },
};
</script>

<style lang="scss">
</style>
